export const NAV_LINKS = [
  { label: "Episodes", href: "/episodes" },
  { label: "About", href: "/about" },
  { label: "Membership", href: "/membership" },
  { label: "Causes", href: "/causes" },
  { label: "Community", href: "/community" },
];

export const MOBILE_LINKS = [
  { label: "Home", href: "/" },
  { label: "Episodes", href: "/episodes" },
  { label: "About", href: "/about" },
  { label: "Membership", href: "/membership" },
  { label: "Causes", href: "/causes" },
  { label: "Community", href: "/community" },
  { label: "Contact", href: "/contact" },
];

export const SOCIALS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/stephanie.thompsonlamar",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/stephanie_roxanne_lamar",
  },
];

export const PLATFORMS = [
  { label: "Spotify", icon: "spotify" },
  { label: "Apple Podcasts", icon: "apple" },
  { label: "YouTube", icon: "youtube" },
  { label: "RSS", icon: "rss" },
];

export const ORGS = {
  "Charis Bible College": "Discipleship, teaching, and equipping students to know the Word and take it into the world.",
  "Truth & Liberty": "Christians engaging culture through biblical worldview training and civic education.",
  "LifeWise Academy": "Released-time Bible education for public school students during the school day.",
  "Normalizing God": "Encouraging everyday conversations about faith so talking about Jesus becomes a natural part of daily life.",
  "Patriot Academy": "Constitutional education and biblical citizenship training for the next generation of leaders.",
  "Leadership Institute": "Practical training for public-facing leaders who want to serve well and stand firm.",
  "Colorado Life Initiative": "A grassroots effort to protect every life, from conception forward, in the state of Colorado.",
  "Down Syndrome for Life — Michigan": "Advocacy and support for families welcoming children with Down syndrome.",
  "The Widows Project": "Practical, ongoing care for widows in the local community — presence, not just programs.",
  "Teller County Republicans": "Local, hands-on citizenship in Stephanie's home county — showing up, listening, serving.",
  "ACT for America — Colorado Springs": "Educating neighbors on threats to freedom and equipping them to respond wisely.",
  "National School Boards Coalition": "Parents and citizens engaging school boards with respect and resolve.",
  "John Guandolo": "National-security education for citizens who want to understand what they're standing for.",
  "RLM Congo": "Discipleship and practical care partnerships across communities in the Democratic Republic of the Congo.",
  "True Mercy Africa": "Compassion and Gospel work meeting real needs across the African continent.",
  "Ambassadors to the Nations": "Sending everyday believers to serve where the Gospel is still new.",
};

export const ORG_GROUPS = [
  {
    title: "Faith & Education",
    orgs: ["Charis Bible College", "Truth & Liberty", "LifeWise Academy", "Normalizing God", "Patriot Academy", "Leadership Institute"],
  },
  {
    title: "Life & Family",
    orgs: ["Colorado Life Initiative", "Down Syndrome for Life — Michigan", "The Widows Project"],
  },
  {
    title: "Liberty & Community",
    orgs: ["Teller County Republicans", "ACT for America — Colorado Springs", "National School Boards Coalition", "John Guandolo"],
  },
  {
    title: "Missions Abroad",
    orgs: ["RLM Congo", "True Mercy Africa", "Ambassadors to the Nations"],
  },
];

export const QUOTE = {
  text: "\u201CI\u2019m not here to win arguments. I\u2019m here to love people enough to tell the truth.\u201D",
  author: "Stephanie",
};
